module.exports = __webpack_public_path__ + "img/quizz-step-11-1.afd40cfe.jpg";